import { useQuery } from 'react-query';
import { api } from '../../../static/api';
import { ApiMobileAppVersion } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import useAxiosInstance from '../../axios/useAxiosInstance';

const useMobileAppVersion = () => {
  const axiosInstance = useAxiosInstance();

  const { data, refetch, isSuccess, isLoading, isError } = useQuery([QueryAliases.MOBILE_APP_VERSION], () =>
    axiosInstance.get(api.endpoints.MOBILE_APP_VERSION),
  );

  const mobileAppVersion: ApiMobileAppVersion | undefined = data?.data;

  return { mobileAppVersion, refetch, isSuccess, isLoading, isError };
};

export default useMobileAppVersion;
